export const GetDeposit = `/Request/GetDeposit?CoinId=-1`;

export const GetDepositWalletCore = ({ coinId, networkId }) =>
  `/Request/GetDepositWalletCore?CoinId=${coinId}&NetworkId=${networkId}`;

export const GetHistoryCryptoList = ({
  sideId,
  typeId,
  coinId,
  dateFrom,
  dateTo,
  stateId,
  pageNumber,
  pageSize,
}) =>
  `/Request/GetHistoryCryptoList?TypeId=${typeId}&CoinId=${coinId}&StartDate=${dateFrom}&EndDate=${dateTo}&SideId=${
    sideId || 0
  }&StateId=${stateId}&PageNumber=${pageNumber}&PageSize=${pageSize}`;

export const GetHistoryFiatList = ({
  sideId,
  dateFrom,
  dateTo,
  stateId,
  pageNumber,
  pageSize,
}) =>
  `/Request/GetHistoryFiatList?SideId=${sideId}&StartDate=${dateFrom}&EndDate=${dateTo}&StateId=${stateId}&PageNumber=${pageNumber}&PageSize=${pageSize}`;

export const GetHistoryCryptoForm = `/Request/GetHistoryCryptoForm`;

export const GetHistoryFiatForm = `/Request/GetHistoryFiatForm`;

export const GetDepositGatewayForm = "/Request/GetDepositGatewayForm";

export const DepositGateway = "/Request/DepositGateway";

export const DepositGatewayVerify = "/Request/DepositGatewayVerify";

export const DepositGatewayVerifyJibimo = "/Request/DepositGatewayVerifyJibimo";
